/* eslint-disable eqeqeq */
import { $consts, $evt } from 'src/plugins'

export default {
  [$consts['LIFECYCLE/EDIT_PAGE_CONTROL_LOADED']] (EditContext: any, props: any) {
    // formId 没有，代表是新增，此时 onEditPageFormLoaded 不会被执行
    if (!props.current.formData?.formId) {
      $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['Parameter9', 'Parameter8'], false)
    }
  },
  [$consts['LIFECYCLE/EDIT_PAGE_FORM_LOADED']] (EditContext: any, props: any) {
    $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['Parameter9', 'Parameter8'], false)
  },
  [$consts['LIFECYCLE/EDIT_PAGE_FORM_CHANGE']] (EditContext: any, FIELD_NAME: string, data: any) {
    if (FIELD_NAME === 'WEB_SITE') {
      const { value: WEB_SITE } = data
      if (!WEB_SITE) {
        EditContext.setFormBase({
          Parameter7: 'enas-ops',
          ParentName: '',
          Parameter3: ''
        })
      } else {
        EditContext.setFormBase({
          ParentName: '',
          Parameter3: ''
        })
      }
    } else if (FIELD_NAME === 'Parameter2') {
      const { value: Parameter2 } = data
      if (!Parameter2) {
        $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['Parameter9'], false)
        $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['Parameter8'], false)
        EditContext.setFormBase({
          Parameter7: '',
          Parameter8: ''
        })
      } else {
        if (Parameter2 == 5) {
          $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['Parameter9'], true)
          $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['Parameter8'], true)
        } else {
          $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['Parameter9'], false)
          $evt.emit($consts['EVT/CONTROL_VISIBLE'], ['Parameter8'], false)
          EditContext.setFormBase({
            Parameter7: '',
            Parameter8: ''
          })
        }

      }
    }
  }
}
